import { graphql, Environment } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';

import {
    LikeItemMutation,
    LikeItemMutation$data,
    LikeItemMutation$rawResponse,
    LikeItemMutation$variables,
} from './__generated__/LikeItemMutation.graphql';

type ItemLikeAction = LikeItemMutation$variables['input']['action'];

const mutation = graphql`
    mutation LikeItemMutation($input: NftItemLikeInput!, $userId: String!, $itemId: String!)
    @raw_response_type {
        nftItemLike(input: $input) {
            nftItem {
                id
                likes {
                    likeCount
                    isLikedByUser(userId: $userId)
                }
            }
            nftItemUserLike {
                id
                nftId
                isLiked
            }
            viewer {
                id
                isNftItemLikedByUser(nftId: $itemId, userId: $userId)
            }
        }
    }
`;

type Params = {
    environment: Environment;
    itemId: string;
    userId: string;
    likeCount: number;
    nodeId: string;
    viewerNodeId: string;
    userLikeNodeId: string;
};

function getOptimisticResponse(
    action: ItemLikeAction,
    likeCount: number,
    nodeId: string,
    itemId: string,
    userLikeNodeId: string,
    viewerNodeId: string
): LikeItemMutation$rawResponse {
    const isLikedByUser = action === 'ADD';
    return {
        nftItemLike: {
            nftItem: {
                id: nodeId,
                likes: {
                    isLikedByUser: isLikedByUser,
                    likeCount: action === 'ADD' ? likeCount + 1 : likeCount - 1,
                },
            },
            nftItemUserLike: {
                id: userLikeNodeId,
                nftId: itemId,
                isLiked: isLikedByUser,
            },
            viewer: {
                id: viewerNodeId,
                isNftItemLikedByUser: isLikedByUser,
            },
        },
    };
}

function executeMutation(
    action: ItemLikeAction,
    { environment, itemId, userId, likeCount, nodeId, viewerNodeId, userLikeNodeId }: Params
): Promise<LikeItemMutation$data> {
    return commitMutation<LikeItemMutation>(environment, {
        mutation,
        variables: {
            input: {
                itemId,
                userId,
                action,
            },
            itemId,
            userId,
        },
        optimisticResponse: getOptimisticResponse(
            action,
            likeCount,
            nodeId,
            itemId,
            userLikeNodeId,
            viewerNodeId
        ),
    });
}

export function addNftItemLike(params: Params): Promise<LikeItemMutation$data> {
    return executeMutation('ADD', params);
}

export function removeNftItemLike(params: Params): Promise<LikeItemMutation$data> {
    return executeMutation('REMOVE', params);
}
